import { NATIVE_ROUTE } from '~~/constants/routes';
import { hasNativeRouteRedirection } from '~~/helpers/navigation/nativeRoutingRedirection';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export const addNativeRoutingToProductUrl = (
  productUrl: string,
  countryCode: CountryCodeValue,
): string => {

  const normalizedProductUrl = productUrl.startsWith('/') ? productUrl : `/${productUrl}`;

  if (!hasNativeRouteRedirection(countryCode)) {

    return normalizedProductUrl;
  
  }
  const isAlreadyNativeRoute = normalizedProductUrl.startsWith(`/${NATIVE_ROUTE.PRODUCT}/`);

  if (isAlreadyNativeRoute) {

    return normalizedProductUrl;
  
  }

  return `/${NATIVE_ROUTE.PRODUCT}${normalizedProductUrl}`;

};

export const transformProductsForNativeRouting =
  (products: ProductVariantExtended[], countryCode: CountryCodeValue): ProductVariantExtended[] => {

    return (products || []).map((product) => {

      const productUrl = hasNativeRouteRedirection(countryCode)
        ? `${NATIVE_ROUTE.PRODUCT}/${product._slug}`
        : product._slug;

      return {
        ...product,
        _slug: productUrl,
      };
    
    });
  
  };
